module.exports = __webpack_public_path__ + "51c093f530ef4c82a02db44c8680f378.svg";